import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { queryClient } from "../lib/queryClient";
import { meQuery, type Me } from "../hooks/useAuth";
import { SettingsShell } from "../components/settings/SettingsShell";

export const Route = createFileRoute("/_auth/settings")({
  staticData: { titleKey: "settings.title", breadcrumbKey: "breadcrumb.manage", breadcrumbN: 2 },
  beforeLoad: () => {
    const me = queryClient.getQueryData<Me>(meQuery.queryKey);
    // `_auth.tsx`'s beforeLoad ensures `me` is populated before this runs.
    // If `me` is somehow missing, fall through to the outer 401 handler.
    if (!me) return;
    if (me.role !== "admin" && me.role !== "manager") {
      throw redirect({ to: "/clients" });
    }
  },
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <SettingsShell>
      <Outlet />
    </SettingsShell>
  );
}
